<template>
    <div class="o-layout o-layout--center">
        <div class="c-panel">

            <h2 class="margin-b-8">Maak een nieuw wachtwoord aan</h2>

            <p>Gebruik minstens 8 tekens. Voeg 1 of meerdere cijfers, hoofdletters en speciale tekens toe om je wachtwoord nog veiliger te maken.</p>

            <c-form ref="form" @valid="submit" :autocomplete="'off'">

                <c-form-element
                    :label="'E-mailadres'">
                    <input type="email" v-model="email" required name="email" />
                </c-form-element>

                <c-form-element
                    :label="'Wachtwoord'"
                    :icon="true"
                    :password="true"
                    @password="hidePassword">
                    <input
                            :type="passwordHidden ? 'password': 'text'"
                            v-model="password"
                            id="password"
                            data-pattern="password"
                            data-error-message="Je wachtwoord moet minimaal uit 1 hoofdletter, 1 kleine letter, 1 cijfer en 1 speciale karakter. Tevens moet het wachtwoord 8 karakters lang zijn"
                            required
                            name="password"
                            autocomplete="new-password"/>
                </c-form-element>

                <c-form-element
                    :label="'Herhaal wachtwoord'"
                    :icon="true"
                    :password="true"
                    @password="hideConfirm">
                    <input
                        :type="confirmHidden ? 'password': 'text'"
                        v-model="password_confirmation"
                        data-pattern="password"
                        data-equalto="password"
                        required
                        name="password_confirmation"
                        autocomplete="new-password"/>
                </c-form-element>

                <p class="color-alert" v-if="error">Helaas konden we het wachtwoord niet aanpassen.</p>

                <button type="submit" class="c-btn c-btn--expanded margin-t-32" ref="submit">Opslaan</button>

            </c-form>

        </div>
    </div>
</template>

<script>
import Form from '@mixins/Form';

export default {
    mixins: [ Form ],
    data() {
        return {
            error: false,
            email: '',
            password: '',
            password_confirmation: '',
            passwordHidden: true,
            confirmHidden: true
        }
    },
    methods: {
        hidePassword(show) {
            this.passwordHidden = !show;
        },

        hideConfirm(show) {
            this.confirmHidden = !show;
        },
        submit() {

            this.error = false;

            this.$xhr.post('/api/auth/password-reset/', {
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                token: this.$route.params.token
            }).then( () => {
                this.$router.push({name: 'renew-password-success'});
            }).catch( () => {
                this.error = true;
            });
        }
    },
    mounted() {

        this.email = this.$route.query && this.$route.query.email ?
                this.$route.query.email : '';
    }
}
</script>
